const spacers = {
    XS: "2px",
    S: "4px",
    M: "8px",
    L: "16px",
    XL: "24px",
    XXL: "32px",
    ["3XL"]: "40px",
    ["4XL"]: "48px"
};
var spacers$1 = spacers;

export { spacers$1 as default };
